<div class="nav-wrapper">
  <nav class="nav-container">
    <div class="buttons-container">
      @if (showNextBtn()) {
        <button
          #primaryButton
          [id]="idText ? idText : 'nextButton'"
          name="calc-next-btn"
          type="button"
          class="app-submit-btn nextButton"
          [ngClass]="{'disabled': loading}"
          [disabled]="disableNextBtn()"
          (click)="onNextBtnClick()">
          {{loading? "": nextBtnText()}}
          @if (showNextBtnIcon()) {
            <div>
              <svg width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.43769 0.332683C1.725 0.332683 2.01113 0.448978 2.22002 0.677974L7.33367 6.28644C7.70193 6.69035 7.70193 7.30834 7.33367 7.71226L2.22002 13.3207C1.82627 13.7526 1.15685 13.7836 0.725102 13.3898C0.29325 12.996 0.262351 12.3268 0.656001 11.8949L5.1197 6.99935L0.656001 2.10379C0.262351 1.67194 0.29325 1.00274 0.725102 0.608873C0.927959 0.4239 1.1833 0.332683 1.43769 0.332683Z"
                  fill="white" />
                </svg>
              </div>
            }
            @if (loading) {
              <div
                [ngClass]="{'spinner': loading }">
              </div>
            }
          </button>
        }

        @if (showBackBtn()) {
          <button
            [id]="idText ? idText : 'backButton'"
            type="button"
            name="calc-back-btn"
            class="app-alt-btn backButton"
            [ngClass]="{'disabled': loading}"
            (click)="onBackBtnClick()">
            @if (showBackBtnIcon()) {
              <div>
                <svg width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.5511 14.6667C10.2638 14.6667 9.97764 14.5504 9.76875 14.3214L4.6551 8.71295C4.28684 8.30904 4.28684 7.69105 4.6551 7.28713L9.76875 1.67866C10.1625 1.24681 10.8319 1.21581 11.2637 1.60956C11.6955 2.00343 11.7264 2.67263 11.3328 3.10448L6.86906 8.00004L11.3328 12.8956C11.7264 13.3274 11.6955 13.9967 11.2637 14.3905C11.0608 14.5755 10.8055 14.6667 10.5511 14.6667Z"
                    fill="#002333" />
                  </svg>
                </div>
              }
              {{loading? "": backBtnText()}}
              @if (loading) {
                <div
                  [ngClass]="{'spinner': loading }">
                </div>
              }
            </button>
          }

          <app-exit-calc-button [ngClass]="{'hideDesktopBtn': !showExitBtnDesktop()}"></app-exit-calc-button>
        </div>
      </nav>
    </div>